/** RTDB kökü — yetki + mail yönlendirme */
export const ACCESS_CONTROL_ROOT = 'access-control'

export const REPORT_KEYS = {
  TESEKKUR: 'tesekkur',
  ONERITALEP: 'oneritalep',
  SIKAYET: 'sikayet',
  RAMAKKALA: 'ramakkala',
  ETIKLIK: 'etiklik',
  ODUL_IK: 'odul_ik',
  ODUL_OPEX: 'odul_opex',
}

export const REPORT_LABELS = {
  [REPORT_KEYS.TESEKKUR]: 'Teşekkür',
  [REPORT_KEYS.ONERITALEP]: 'Talep',
  [REPORT_KEYS.SIKAYET]: 'Şikayet',
  [REPORT_KEYS.RAMAKKALA]: 'Tehlikeli Durum & Ramak Kala',
  [REPORT_KEYS.ETIKLIK]: 'Etik',
  [REPORT_KEYS.ODUL_IK]: 'Ödül Öneri (İK)',
  [REPORT_KEYS.ODUL_OPEX]: 'Ödül Öneri (OPEX)',
}

export const MAIL_ROUTE_KEYS = [
  'etiklik',
  'ramakkala',
  'tesekkur',
  'sikayet',
  'oneri-talep',
  'default',
]

export const MAIL_ROUTE_LABELS = {
  etiklik: 'Etik',
  ramakkala: 'Tehlikeli Durum & Ramak Kala',
  tesekkur: 'Teşekkür',
  sikayet: 'Şikayet',
  'oneri-talep': 'Talep',
  default: 'Varsayılan (diğer konular)',
}

/** Firebase RTDB key: nokta kullanılamaz */
export const emailToKey = (email) =>
  String(email || '')
    .trim()
    .toLowerCase()
    .replace(/\./g, ',')

export const emptyReports = () => ({
  [REPORT_KEYS.TESEKKUR]: false,
  [REPORT_KEYS.ONERITALEP]: false,
  [REPORT_KEYS.SIKAYET]: false,
  [REPORT_KEYS.RAMAKKALA]: false,
  [REPORT_KEYS.ETIKLIK]: false,
  [REPORT_KEYS.ODUL_IK]: false,
  [REPORT_KEYS.ODUL_OPEX]: false,
})

/** Mevcut hardcoded listelerden türetilen ilk seed */
export const buildSeedPermissions = () => {
  const allClassic = {
    ...emptyReports(),
    tesekkur: true,
    oneritalep: true,
    sikayet: true,
    ramakkala: true,
    etiklik: true,
    odul_ik: true,
    odul_opex: true,
  }

  const nonEtik = {
    ...emptyReports(),
    tesekkur: true,
    oneritalep: true,
    sikayet: true,
    ramakkala: true,
    etiklik: false,
    odul_ik: true,
    odul_opex: false,
  }

  const ramakOnly = {
    ...emptyReports(),
    ramakkala: true,
  }

  const etikOnlyPlus = {
    ...emptyReports(),
    tesekkur: true,
    oneritalep: true,
    sikayet: true,
    ramakkala: true,
    etiklik: true,
    odul_ik: false,
  }

  const map = {}

  const put = (email, reports) => {
    const e = String(email).trim().toLowerCase()
    if (!e) return
    const prev = map[e]?.reports || emptyReports()
    map[e] = {
      email: e,
      reports: {
        tesekkur: prev.tesekkur || reports.tesekkur,
        oneritalep: prev.oneritalep || reports.oneritalep,
        sikayet: prev.sikayet || reports.sikayet,
        ramakkala: prev.ramakkala || reports.ramakkala,
        etiklik: prev.etiklik || reports.etiklik,
        odul_ik: prev.odul_ik || reports.odul_ik,
        odul_opex: prev.odul_opex || reports.odul_opex,
      },
    }
  }

  // ETIK_AUTHORIZED — tam rapor + (melih/gulsunay ayrıca İK)
  ;['erbil@karporselen.com', 'gulsunay.uysal@bonna.com.tr', 'melih.karatay@bonna.com.tr'].forEach(
    (e) => put(e, etikOnlyPlus)
  )
  ;['melih.karatay@bonna.com.tr', 'gulsunay.uysal@bonna.com.tr', 'merve.aksoy@bonna.com.tr'].forEach(
    (e) => put(e, { ...emptyReports(), odul_ik: true })
  )
  ;['melih.karatay@bonna.com.tr', 'alper.odabasi@bonna.com.tr'].forEach((e) =>
    put(e, { ...emptyReports(), odul_opex: true, odul_ik: true })
  )
  // NON_ETIK_ALL
  ;['yunus.emre@bonna.com.tr', 'merve.aksoy@bonna.com.tr'].forEach((e) => put(e, nonEtik))
  // RAMAKKALA_ONLY
  ;['izzet.diker@bonna.com.tr', 'ahmet.duran@bonna.com.tr', 'isg@bonna.com.tr'].forEach((e) =>
    put(e, ramakOnly)
  )

  // melih full
  put('melih.karatay@bonna.com.tr', allClassic)

  return map
}

export const buildSeedMailRoutes = () => {
  const defaultTo = String(process.env.REACT_APP_MAIL_TO_ADDRESS || 'feedback@bonna.com.tr')
    .trim()
    .toLowerCase()
  const classic = {
    to: defaultTo ? [defaultTo] : [],
    cc: [],
  }
  return {
    etiklik: {
      to: ['gulsunay.uysal@bonna.com.tr'],
      cc: ['erbil@karporselen.com'],
    },
    ramakkala: {
      to: ['izzet.diker@bonna.com.tr', 'isg@bonna.com.tr'],
      cc: [],
    },
    // Eskiden hardcoded yoktu → REACT_APP_MAIL_TO_ADDRESS’e düşüyordu
    tesekkur: { ...classic, to: [...classic.to] },
    sikayet: { ...classic, to: [...classic.to] },
    'oneri-talep': { ...classic, to: [...classic.to] },
    default: { ...classic, to: [...classic.to] },
  }
}

/** topic string → mailRoutes key */
export const topicToMailRouteKey = (topic) => {
  const t = String(topic || '').trim()
  if (t === 'Etiklik') return 'etiklik'
  if (t === 'Tehlikeli Durum & Ramak Kala') return 'ramakkala'
  if (t === 'Teşekkür') return 'tesekkur'
  if (t === 'Talep' || t === 'Öneri Talep' || t === 'Oneri Talep' || t === 'Öneri & Talep') {
    return 'oneri-talep'
  }
  if (t === 'Şikayet') return 'sikayet'
  return 'default'
}
